import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: "#BF3B3B",
        accent: "#FF8A80",
        error: "#FF5722",
      }
    }
  },
});
